/* KORZAVI — Christmas decoration.
   Loaded only while Admin → Content → Metaobjects → Store decoration says Christmas (or Auto, between the dates in Season scene). */
(() => {
  /* A ?decor= preview link can switch the season after this file was requested */
  if (document.documentElement.dataset.decor !== 'christmas') return;
  const $ = (s, c = document) => c.querySelector(s);
  const T = (window.KZ && window.KZ.strings) || {};
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const small = matchMedia('(max-width: 749px)');
  const snd = (n, o) => { if (window.KZSound) window.KZSound.play(n, o); };
  const mk = (tag, cls, inner) => { const e = document.createElement(tag); e.className = cls; if (inner) e.innerHTML = inner; return e; };
  const button = (cls, label, inner) => { const b = mk('button', 'kzd-btn ' + cls, inner); b.type = 'button'; b.setAttribute('aria-label', label); return b; };
  const pulse = (el, cls, ms) => { el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); clearTimeout(el._t); el._t = setTimeout(() => el.classList.remove(cls), ms); };
  const header = $('[data-header]');
  const footer = $('.kz-footer');
  const hero = $('.hero');
  const COLORS = ['#ff4d5e', '#3ddc84', '#ffd27a', '#4da3ff', '#ff7ad9'];

  const SVG = {
    hat: '<svg viewBox="0 0 64 50" aria-hidden="true"><path d="M8 38C12 20 24 6 42 6c8 0 13 6 15 14l-6 3c-2-5-5-7-9-7-9 0-15 10-17 22z" fill="#d6203a"/><path d="M42 6c8 0 13 6 15 14l-6 3c-2-5-5-7-9-7z" fill="#b5162c"/><rect x="2" y="34" width="38" height="12" rx="6" fill="#f5f7fa"/><circle cx="56" cy="24" r="6.5" fill="#f5f7fa"/></svg>',
    ball: (c) => `<svg viewBox="0 0 40 50" aria-hidden="true"><rect x="15" y="2" width="10" height="7" rx="2" fill="#d9b45a"/><circle cx="20" cy="29" r="17" fill="${c}"/><path d="M4.5 26q15.5 7 31 0" stroke="rgba(255,255,255,.55)" stroke-width="2.4" fill="none"/><ellipse cx="13" cy="21" rx="4.5" ry="6" fill="rgba(255,255,255,.4)" transform="rotate(30 13 21)"/></svg>`
  };

  /* Gentle snowfall (decorative; skipped with reduced motion) */
  if (!reduce) {
    const cv = mk('canvas', 'kzd-snow');
    cv.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cv);
    const c = cv.getContext('2d');
    let W = 0, H = 0, flakes = [], raf = 0, last = 0;
    const make = (y) => ({ x: Math.random() * W, y: y == null ? Math.random() * H : y, r: 1 + Math.random() * 2.2, v: 0.25 + Math.random() * 0.6, p: Math.random() * 6.28, w: 0.4 + Math.random() * 0.8 });
    const size = () => {
      const dpr = Math.min(2, window.devicePixelRatio || 1);
      W = innerWidth; H = innerHeight;
      cv.width = W * dpr; cv.height = H * dpr;
      c.setTransform(dpr, 0, 0, dpr, 0, 0);
      const n = small.matches ? 16 : 40;
      flakes = Array.from({ length: n }, () => make());
    };
    const tick = (now) => {
      const dt = last ? Math.min(3, (now - last) / 16.7) : 1;
      last = now;
      c.clearRect(0, 0, W, H);
      c.fillStyle = 'rgba(255,255,255,.75)';
      c.beginPath();
      flakes.forEach((f, i) => {
        f.y += f.v * dt;
        f.p += 0.012 * f.w * dt;
        const x = f.x + Math.sin(f.p) * 14;
        if (f.y > H + 6) flakes[i] = make(-6);
        c.moveTo(x + f.r, f.y);
        c.arc(x, f.y, f.r, 0, 6.283);
      });
      c.fill();
      raf = requestAnimationFrame(tick);
    };
    const run = () => { cancelAnimationFrame(raf); last = 0; if (!document.hidden) raf = requestAnimationFrame(tick); };
    size();
    run();
    let rt = 0;
    addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(size, 150); });
    document.addEventListener('visibilitychange', run);
  }

  if (header) {
    /* A garland of lights along the bottom of the header; each light chimes when the cursor passes */
    const g = mk('div', 'kzd-lights');
    const wire = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    wire.setAttribute('class', 'kzd-lights__wire');
    wire.setAttribute('aria-hidden', 'true');
    g.appendChild(wire);
    const label = button('kzd-lights__btn', T.decorLights || 'Holiday lights', '');
    label.addEventListener('click', () => {
      g.querySelectorAll('.kzd-bulb').forEach((b, i) => setTimeout(() => pulse(b, 'is-on', 500), i * 45));
      snd('chime');
    });
    g.appendChild(label);
    header.appendChild(g);
    const build = () => {
      g.querySelectorAll('.kzd-bulb').forEach((b) => b.remove());
      const w = header.clientWidth;
      const n = Math.max(8, Math.min(26, Math.round(w / 58)));
      const seg = w / n;
      let d = 'M0 3';
      for (let i = 0; i < n; i++) {
        const x0 = i * seg, x1 = x0 + seg;
        d += ` Q${(x0 + x1) / 2} 17 ${x1} 3`;
        const b = mk('span', 'kzd-bulb');
        b.style.cssText = `left:${x0 + seg / 2}px;--c:${COLORS[i % COLORS.length]};--dl:${(i % 7) * 0.37}s`;
        b.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse') return;
          pulse(b, 'is-on', 650);
          snd('tinkle', { i, hover: true, gap: 250 });
        });
        g.appendChild(b);
      }
      wire.setAttribute('viewBox', `0 0 ${w} 20`);
      wire.innerHTML = `<path d="${d}" fill="none" stroke="#2c3a2c" stroke-width="2"/>`;
    };
    build();

    /* A Santa hat on the K of the logo */
    const k = $('.kz-brand .kz-k, .kz-brand img', header);
    const hat = button('kzd-hat', T.decorHat || 'Santa hat', SVG.hat);
    hat.addEventListener('click', () => { pulse(hat, 'is-shake', 700); snd('jingle'); });
    header.appendChild(hat);
    const placeHat = () => {
      if (!k) { hat.hidden = true; return; }
      const r = k.getBoundingClientRect(), h = header.getBoundingClientRect();
      hat.hidden = r.width === 0;
      hat.style.width = Math.round(r.width * 1.15) + 'px';
      hat.style.left = Math.round(r.left - h.left - r.width * 0.12) + 'px';
      hat.style.top = Math.round(r.top - h.top - r.width * 0.62) + 'px';
    };
    placeHat();
    let rt = 0;
    addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(() => { build(); placeHat(); }, 150); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeHat);
    addEventListener('load', placeHat);
  }

  /* Ornaments hanging in the home banner; a click makes one swing and ring */
  if (hero) {
    const box = mk('div', 'kzd-orns');
    [[5, 120], [13, 64], [87, 92], [95, 140]].forEach(([x, len], i) => {
      const o = button('kzd-orn', T.decorOrnament || 'Ornament', '<span class="kzd-orn__str"></span>' + SVG.ball(COLORS[[0, 2, 1, 3][i]]));
      o.style.cssText = `left:${x}%;--len:${len}px;--dl:${i * 0.8}s`;
      o.addEventListener('click', () => { pulse(o, 'is-swing', 1700); snd('note', { i }); });
      box.appendChild(o);
    });
    hero.appendChild(box);
  }

  /* Snow resting on the top edge of the footer */
  if (footer) {
    const cap = mk('span', 'kzd-cap');
    cap.setAttribute('aria-hidden', 'true');
    footer.appendChild(cap);
  }
})();
